import i18n from "@/i18n";
import requireAuthorization from "@/routes/helper/requireAuthorization";
import { PermitionEnum } from "@/components/security/Permitions";

export default [
    {
        path: "/authorizations",
        name: "authorizations",
        component: () => import("@/components/authorizations/_Authorizations.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.ViewAuthorizationsUI,
            breadcrumbs: {
                icon: "authorization-icon",
                paths: []
            },
            title: "navbar.authorizations"
        }
    },
    {
        path: "/authorizations/ropc/:authorizationId/update",
        name: "updateRopcAuthorization",
        component: () => import("@/components/authorizations/_ROPCForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.UpdateAuthorization,
            breadcrumbs: {
                icon: "authorization-icon",
                paths: [
                    ["/authorizations", i18n.t("authorization.title")]
                ]
            }
        },
        props: true
    },
    {
        path: "/authorizations/ropc/new",
        name: "createRopcAuthorization",
        component: () => import("@/components/authorizations/_ROPCForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.CreateAuthorization,
            breadcrumbs: {
                icon: "authorization-icon",
                paths: [
                    ["/authorizations", i18n.t("authorization.title")]
                ]
            },
            title: "authorization.createTitle"
        },
        props: true
    },
    {
        path: "/authorizations/acf/:authorizationId/update",
        name: "updateAcfAuthorization",
        component: () => import("@/components/authorizations/_ACFForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.UpdateAuthorization,
            breadcrumbs: {
                icon: "authorization-icon",
                paths: [
                    ["/authorizations", i18n.t("authorization.title")]
                ]
            }
        },
        props: true
    },
    {
        path: "/authorizations/acf/new",
        name: "createAcfAuthorization",
        component: () => import("@/components/authorizations/_ACFForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.CreateAuthorization,
            breadcrumbs: {
                icon: "authorization-icon",
                paths: [
                    ["/authorizations", i18n.t("authorization.title")]
                ]
            },
            title: "authorization.createTitle"
        },
        props: true
    },
    {
        path: "/authorizations/ccf/:authorizationId/update",
        name: "updateCcfAuthorization",
        component: () => import("@/components/authorizations/_CCFForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.UpdateAuthorization,
            breadcrumbs: {
                icon: "authorization-icon",
                paths: [
                    ["/authorizations", i18n.t("authorization.title")]
                ]
            }
        },
        props: true
    },
    {
        path: "/authorizations/ccf/new",
        name: "createCcfAuthorization",
        component: () => import("@/components/authorizations/_CCFForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.CreateAuthorization,
            breadcrumbs: {
                icon: "authorization-icon",
                paths: [
                    ["/authorizations", i18n.t("authorization.title")]
                ]
            },
            title: "authorization.createTitle"
        },
        props: true
    },
    {
        path: "/authResponse",
        name: "authResponse",
        component: () => import("@/components/authorizations/_AuthResponse.vue"),
        meta: {
            title: "authorization.title",
            layout: "basic-layout"
        }
    }
];
